import { MouseEvent, useState } from 'react'
import clsx from 'clsx'
import { Moon, Sun } from 'lucide-react'

const readIsDark = () => document.documentElement.classList.contains('dark')

export const ThemeToggle = () => {
  const [dark, setDark] = useState(readIsDark)

  const applyTheme = (nextDark: boolean) => {
    document.documentElement.classList.toggle('dark', nextDark)
    setDark(nextDark)
  }

  const onToggle = (e: MouseEvent<HTMLButtonElement>) => {
    const nextDark = !dark
    const root = document.documentElement
    root.style.setProperty('--transition-x', `${e.clientX}px`)
    root.style.setProperty('--transition-y', `${e.clientY}px`)

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (prefersReducedMotion || typeof document.startViewTransition !== 'function') {
      applyTheme(nextDark)
      return
    }

    document.startViewTransition(() => {
      applyTheme(nextDark)
    })
  }

  return (
    <button
      type="button"
      role="switch"
      aria-checked={dark}
      onClick={onToggle}
      className="inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full transition-colors duration-200"
      style={{
        backgroundColor: dark ? 'var(--primary-500)' : 'var(--muted)',
        border: '1px solid var(--border)',
      }}
    >
      <span
        className={clsx(
          'flex h-5 w-5 items-center justify-center rounded-full shadow-sm transition-transform duration-200',
          dark ? 'translate-x-[22px]' : 'translate-x-px',
        )}
        style={{ backgroundColor: '#ffffff' }}
      >
        {dark ? <Moon size={12} color="#1f2937" /> : <Sun size={12} color="#b45309" />}
      </span>
    </button>
  )
}
